import React from 'react';
export function Footer() {
  const navLinks = [{
    name: 'Framework',
    href: '#framework'
  }, {
    name: 'Problems We Fix',
    href: '#problems'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Results',
    href: '#results'
  }, {
    name: 'Guarantee',
    href: '#guarantee'
  }, {
    name: 'Packages',
    href: '#packages'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-white/10" data-id="element-120">
      <div className="container-custom" data-id="element-121">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-122">
          <div className="lg:col-span-2" data-id="element-123">
            <img src="https://images.squarespace-cdn.com/content/v1/68dc0e53776b445a6a757253/a9936dc6-91ee-4e79-bb13-a7129d009d85/FSG-logo-white%2B%281%29.png" alt="FleetScale Group" className="h-8 w-auto mb-6" data-id="element-124" />
            <p className="text-white/60 text-sm leading-relaxed max-w-md" data-id="element-125">
              FleetScale Group helps trucking company owners build scalable
              operations, stronger systems, and more predictable growth.
            </p>
          </div>

          <div data-id="element-126">
            <h4 className="font-heading font-bold uppercase tracking-wider text-sm mb-6 text-white/90" data-id="element-127">
              Navigation
            </h4>
            <ul className="space-y-3" data-id="element-128">
              {navLinks.slice(0, 4).map(link => <li key={link.name} data-id="element-129">
                  <a href={link.href} className="text-white/60 hover:text-white text-sm transition-colors" data-id="element-130">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-131">
            <h4 className="font-heading font-bold uppercase tracking-wider text-sm mb-6 text-white/90" data-id="element-132">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-133">
              {navLinks.slice(4).map(link => <li key={link.name} data-id="element-134">
                  <a href={link.href} className="text-white/60 hover:text-white text-sm transition-colors" data-id="element-135">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between" data-id="element-136">
          <p className="text-white/40 text-xs mb-4 md:mb-0" data-id="element-137">
            &copy; {new Date().getFullYear()} FleetScale Group. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-138">
            <a href="#" className="text-white/40 hover:text-white text-xs transition-colors" data-id="element-139">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white text-xs transition-colors" data-id="element-140">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}